/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {ErrorType, ResponseData, setJwt, showDialog, validateEmail} from '@dvrd/dvr-controls';
import React, {useContext, useState} from 'react';
import {Navigate, useNavigate} from 'react-router';
import User from '../../../models/userModel';
import {AUTHENTICATED_URL} from '../../../util/constants';
import {login} from '../../../util/requestSender';
import {createErrorMessage} from '../../../util/utils';
import {AppContext} from '../../context/appContext';
import LoginView from './loginView';

export default function LoginController() {
    const context = useContext(AppContext);
    if (context.userContext.user) return <Navigate to='/ritten'/>;
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<ErrorType>(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    function onChange(key: string) {
        return function (value: string) {
            if (key === 'email') setEmail(value);
            else if (key === 'password') setPassword(value);
        };
    }

    function onSubmit() {
        if (!validateValues()) return;
        setLoading(true);
        login({
            data: {email, password},
            callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    const user = new User(data.user);
                    const jwt = data.token;
                    setJwt(jwt);
                    context.onChangeContext({user}, () => {
                        navigate(AUTHENTICATED_URL);
                    });
                } else if (data.message) setError(data.message);
                else showDialog(createErrorMessage('Het inloggen is niet gelukt.'), 'Inloggen mislukt');
            }
        });
    }

    function onResetError() {
        setError(null);
    }

    function validateValues(): boolean {
        let error: ErrorType = null;
        if (!email) error = 'Vul je e-mailadres in';
        else if (!validateEmail(email)) error = 'Vul een geldig e-mailadres in';
        if (!password) error = 'Vul je wachtwoord in';
        setError(error);
        return error === null;
    }

    return (
        <>
            <LoginView onSubmit={onSubmit} onChange={onChange} onFocusField={onResetError} email={email}
                       password={password} loading={loading} error={error}/>
        </>
    );
}